import { render, staticRenderFns } from "./ims-policy.vue?vue&type=template&id=fbd860be&"
import script from "./ims-policy.vue?vue&type=script&lang=js&"
export * from "./ims-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports